import styled from "@emotion/styled";
import { Col } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";

const DashboadContainer = styled.div<IStyledComponentProps>`
  &.dashboard-container {
    .dashboard-card {
      height: 600px;
      overflow-y: scroll;
    }
  }
`;

const ResultsContainer = styled.div<IStyledComponentProps>`
  &.results-container {
    margin-top: 32px;
  }
`;

export default { DashboadContainer, ResultsContainer };
